<cw-header class="main-header">
  <div slot="start" class="header-aside">
    <img
      [ngSrc]="logoUrl"
      width="87"
      height="16"
      priority
      [alt]="i18n.t('app.logo')"
      class="main-logo"
    />

    <span class="main-header-title">{{ i18n.t('app.title') }}</span>
  </div>

  <div slot="end">
    <cw-avatar-menu
      id="app-avatar-menu"
      data-testid="avatar-menu"
      firstName="Name"
      lastName="Surname"
      email="namesurname@bbraun.com"
      avatarType="letters"
      [isOnline]="true"
      [labels]="avatarLabels()"
      (navigate)="onAvatarMenuNavigate($event)"
    ></cw-avatar-menu>
  </div>
</cw-header>
